import gql from 'graphql-tag';

export const LOGIN_USER = gql`
  mutation ($email: String!, $password: String!) {
    login(email: $email,  password: $password) {
      access_token
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/auth/login.js